import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {connect} from "react-redux";
import {Box} from "@material-ui/core";
import StyledButton from "./StyledButton";
import {useHistory} from "react-router-dom";
import {getTitle, getOptionCount, getMatchingClientStatusTitle} from '../../shared/vehicle';
import {getCondition} from "../../shared/conditions";
import * as actions from '../../store/actions';
import VehicleCarousel from '../../containers/Dashboard/Vehicle/VehicleCarousel';
import { DashboardStyles } from '../../styles/dashboard';


const useStyles = makeStyles(DashboardStyles);

const SelectedVehicleDetails = (props) => {

    const classes = useStyles();
    const history = useHistory();
    let vehicle

    vehicle = props.vehicles[props.selectedVehicleIndex]
    if (vehicle) {
        const subCaption = [vehicle.trim];

        // let totalOptions = 0

        // if (vehicle.options) {
        //     for (const [key, value] of Object.entries(vehicle.options)) {
        //         if (value) {
        //             totalOptions++
        //         }
        //     }
        // }

        const mileage = vehicle.mileage ? Intl.NumberFormat('en-US', {style: 'decimal'}).format(vehicle.mileage) : ''

        const conditions = []
        conditions.push(vehicle.interiorCondition)
        conditions.push(vehicle.exteriorCondition)
        conditions.push(vehicle.mechanicalCondition)
        const getCondition = () => {
            if (conditions.find(element => element === 'Rough'))
                return 'Rough'
            if (conditions.find(element => element === 'Below Average'))
                return 'Below Average'
            if (conditions.find(element => element === 'Average'))
                return 'Average'
            if (conditions.find(element => element === 'Good'))
                return 'Good'
            if (conditions.find(element => element === 'Excellent'))
                return 'Excellent'
        }
        const mcStatusTitle = getMatchingClientStatusTitle(vehicle);


        return (

            <Box className={classes.selectedVehicleDetailRoot} flexDirection="row" style={{width: '100%', color: 'white'}}>
                <Box className='frame-carousel mobile'>
                    <VehicleCarousel vehicle={props.selectedVehicle} />
                </Box>
                <Box style={{fontSize: '24px', fontWeight: 'bold'}}>{getTitle(vehicle)}</Box>
                <Box style={{fontSize: '20px'}}>{subCaption.join(' ').trim()}</Box>
                {mcStatusTitle && <Box className='status'>Status: <span>{mcStatusTitle}</span></Box>}
                <Box display="flex" flexDirection="row"
                     style={{fontSize: '20px', fontWeight: "bold", marginTop: '10px'}}>
                    Vehicle Details
                </Box>
                <Box display="flex" flexDirection="row" className={'data-box'}>
                    <Box className={'box-caption'}>VIN:</Box>
                    <Box>{vehicle.vin}</Box>
                </Box>
                <Box display="flex" flexDirection="row" className={'data-box'}>
                    <Box className={'box-caption'}>Mileage:</Box>
                    <Box>{mileage}</Box>
                </Box>
                <Box display="flex" flexDirection="row" className={'data-box'}>
                    <Box className={'box-caption'}>Condition:</Box>
                    <Box>{getCondition()}</Box>
                </Box>
                <Box display="flex" flexDirection="row" className={'data-box'}>
                    <Box className={'box-caption'}>Color:</Box>
                    <Box>{(vehicle.exteriorColor)?vehicle.exteriorColor.name: '' }</Box>
                </Box>
                <Box display="flex" flexDirection="row" className={'data-box'}>
                    <Box className={'box-caption'}>Aftermarket Parts:</Box>
                    <Box>{vehicle.hasAftermarketParts ? 'Yes' : 'No'}</Box>
                </Box>
                <Box display="flex" flexDirection="row" className={'data-box'}>
                    <Box className={'box-caption'}>Total Options:</Box>
                    <Box>{getOptionCount(vehicle)}</Box>
                </Box>
                <Box display="flex" justifyContent="flex-end">
                    {false && <StyledButton
                        buttonProps={{
                            variant: "contained",
                            color: "primary",
                            onClick: () => {
                                props.onSetSelectedVehicle(vehicle, () => {
                                    history.push('/dashboard/vehicle/' + vehicle.id);
                                });
                            },
                            className: classes.button,
                            //disabled:uploading
                        }}
                        label={'Edit'}
                    />}
                </Box>
            </Box>
        )
    } else {
        return <React.Fragment></React.Fragment>
    }
}

const mapStateToProps = state => {
    return {
        account: state.account,
        selectedVehicleIndex: state.app.selectedVehicleIndex,
        selectedVehicle: state.app.selectedVehicle
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSetSelectedVehicle: (vehicle, cb) => dispatch(actions.gatherInfo(vehicle, cb))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectedVehicleDetails);